import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Box,
  Typography,
  Stack,
  Pagination,
} from '@mui/material';

const CommonDataCard = ({ row, fields }) => {
  return (
    <Card
      sx={{
        border: '1px solid #E6E6E6',
        borderRadius: '12px',
        p: 2,
        background: '#fff',
        height: '100%',
        boxShadow: 'none',
      }}
    >
      <CardContent>
        {/* Fields */}
        {fields.map(item => (
          <Box
            key={item.label}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            gap={3}
            mb={2}
            textAlign="left"
          >
            <Typography color="gray" textAlign="left">
              {item.headerName}
            </Typography>

            {item.renderCell ? (
              <Box
                sx={{
                  '& .MuiTypography-root': { textAlign: 'right !important' },
                }}
              >
                {item.renderCell({ row })}
              </Box>
            ) : (
              <Typography fontWeight={500} textAlign="right">
                {row[item.field] || '-'}
              </Typography>
            )}
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};

const CommonCardView = ({ rows, fields }) => {
  const pageSize = 6;

  const [page, setPage] = useState(0);

  const start = page * pageSize;
  const end = start + pageSize;

  const paginatedRows = rows.slice(start, end);

  const totalPages = Math.ceil(rows.length / pageSize);

  return (
    <Box px={2}>
      <Grid container spacing={2}>
        {paginatedRows.map(row => (
          <Grid item xs={12} sm={6} key={row.id}>
            <CommonDataCard row={row} fields={fields} />
          </Grid>
        ))}
      </Grid>

      <Stack alignItems="center" mt={3}>
        <Pagination
          count={totalPages}
          page={page + 1}
          onChange={(e, value) => setPage(value - 1)}
          color="primary"
        />
      </Stack>
    </Box>
  );
};

export default CommonCardView;
